import { UserCircle } from "@phosphor-icons/react";
import { m } from "@plannello/i18n/messages";
import { createFileRoute } from "@tanstack/react-router";
import { validateViewSearch } from "@/components/items/viewSearch";
import { WorkView } from "@/components/items/WorkView";
import { useRunCommand } from "@/components/shell/useRunCommand";
import { Button, EmptyState, Kbd, KeyHint } from "@/components/ui";

export const Route = createFileRoute("/_app/")({ validateSearch: validateViewSearch, component: MyWork });

const SORT = [
  { key: "priority" as const, dir: "desc" as const },
  { key: "rank" as const, dir: "asc" as const },
];

/** Open items assigned to me across every product, most urgent first, grouped by status. */
function MyWork() {
  const search = Route.useSearch();
  const run = useRunCommand();
  return (
    <WorkView
      title={m.nav_my_work()}
      icon={UserCircle}
      meta={m.mywork_meta()}
      baseQuery="assignee:me is:open"
      search={search}
      defaultGroup="status"
      defaultSort={SORT}
      defaultSortParam="priority"
      viewKey="my-work"
      empty={
        <EmptyState
          title={m.mywork_empty_title()}
          description={m.mywork_empty_body()}
          action={
            <Button variant="primary" onPress={() => run("create")}>
              {m.action_create_item()}
              <Kbd keys={["C"]} tone="inverse" className="-mr-1 ml-1" />
            </Button>
          }
          secondary={
            <Button variant="secondary" onPress={() => run("import.github")}>
              {m.import_github()}
            </Button>
          }
          hint={
            <>
              <KeyHint keys={["mod", "K"]}>{m.hint_command_palette()}</KeyHint>
              <KeyHint keys={["G", "I"]}>{m.nav_inbox()}</KeyHint>
            </>
          }
        />
      }
    />
  );
}
